// Michigan 103rd Legislature (2025-2026) Committee Data
// House data updated: 1/31/2025 (Standing), 2/5/2025 (Subcommittees)
// Senate data updated: 1/22/2025 (Standing), 2/4/2025 (Subcommittees)

const MI_COMMITTEES = [

  // ─── HOUSE STANDING COMMITTEES ────────────────────────────
  {
    id: "house-agriculture",
    chamber: "House",
    type: "Standing",
    name: "Agriculture",
    parent: null,
    location: "Room 308, House Office Building, Lansing, MI",
    clerk: "Brittany Middaugh",
    clerk_phone: "(517) 373-8474",
    clerk_email: "bmiddaugh@house.mi.gov",
    members: [
      { name: "Jerry Neyer", role: "Chair" },
      { name: "Jennifer Wortz", role: "Majority Vice Chair" },
      { name: "Veronica Paiz", role: "Minority Vice Chair" },
      { name: "Sarah Lightner", role: "Member" },
      { name: "Gregory Alexander", role: "Member" },
      { name: "Joseph Fox", role: "Member" },
      { name: "Tom Kunse", role: "Member" },
      { name: "Joseph Pavlov", role: "Member" },
      { name: "Emily Dievendorf", role: "Member" },
      { name: "Carrie Rheingans", role: "Member" },
      { name: "Phil Skaggs", role: "Member" },
    ]
  },
  {
    id: "house-appropriations",
    chamber: "House",
    type: "Standing",
    name: "Appropriations",
    parent: null,
    location: "Room 352, House Appropriations, State Capitol Building, Lansing, MI",
    clerk: "Dakota Soda",
    clerk_phone: "(517) 373-0350",
    clerk_email: "dsoda@house.mi.gov",
    members: [
      { name: "Ann Bollin", role: "Chair" },
      { name: "Matt Maddock", role: "Majority Vice Chair" },
      { name: "Alabas Farhat", role: "Minority Vice Chair" },
      { name: "Phil Green", role: "Member" },
      { name: "Nancy Jenkins-Arno", role: "Member" },
      { name: "Tim Kelly", role: "Member" },
      { name: "Greg Markkanen", role: "Member" },
      { name: "Mike Mueller", role: "Member" },
      { name: "Bradley Slagh", role: "Member" },
      { name: "Greg VanWoerkom", role: "Member" },
      { name: "Timothy Beson", role: "Member" },
      { name: "Ken Borton", role: "Member" },
      { name: "John Roth", role: "Member" },
      { name: "Cameron Cavitt", role: "Member" },
      { name: "James DeSana", role: "Member" },
      { name: "Tom Kuhn", role: "Member" },
      { name: "Donni Steele", role: "Member" },
      { name: "Ron Robinson", role: "Member" },
      { name: "Amos O'Neal", role: "Member" },
      { name: "Julie Rogers", role: "Member" },
      { name: "Samantha Steckloff", role: "Member" },
      { name: "Carol Glanville", role: "Member" },
      { name: "Kimberly Edwards", role: "Member" },
      { name: "Jasper Martus", role: "Member" },
      { name: "Donavan McKinney", role: "Member" },
      { name: "Jason Morgan", role: "Member" },
      { name: "Natalie Price", role: "Member" },
      { name: "Will Snyder", role: "Member" },
      { name: "Matt Longjohn", role: "Member" },
    ]
  },
  {
    id: "house-communications-technology",
    chamber: "House",
    type: "Standing",
    name: "Communications and Technology",
    parent: null,
    location: "Room 327, House Office Building, Lansing, MI",
    clerk: "Brittany Middaugh",
    clerk_phone: "(517) 373-8474",
    clerk_email: "bmiddaugh@house.mi.gov",
    members: [
      { name: "Jaime Greene", role: "Chair" },
      { name: "Tom Kunse", role: "Majority Vice Chair" },
      { name: "Helena Scott", role: "Minority Vice Chair" },
      { name: "Pauline Wendzel", role: "Member" },
      { name: "Kathy Schmaltz", role: "Member" },
      { name: "Josh Schriver", role: "Member" },
      { name: "Parker Fairbairn", role: "Member" },
      { name: "Rylee Linting", role: "Member" },
      { name: "Joey Andrews", role: "Member" },
      { name: "Noah Arbit", role: "Member" },
      { name: "Phil Skaggs", role: "Member" },
    ]
  },
  {
    id: "house-economic-competitiveness",
    chamber: "House",
    type: "Standing",
    name: "Economic Competitiveness",
    parent: null,
    location: "Room 521, House Office Building, Lansing, MI",
    clerk: "Dakota Soda",
    clerk_phone: "(517) 373-0350",
    clerk_email: "dsoda@house.mi.gov",
    members: [
      { name: "Mike Hoadley", role: "Chair" },
      { name: "Karl Bohnak", role: "Majority Vice Chair" },
      { name: "Kristian Grant", role: "Minority Vice Chair" },
      { name: "Pat Outman", role: "Member" },
      { name: "Mike Harris", role: "Member" },
      { name: "Brian BeGole", role: "Member" },
      { name: "Jay DeBoyer", role: "Member" },
      { name: "Alicia St. Germaine", role: "Member" },
      { name: "Julie Brixie", role: "Member" },
      { name: "Joseph Tate", role: "Member" },
      { name: "Betsy Coffia", role: "Member" },
    ]
  },
  {
    id: "house-education-workforce",
    chamber: "House",
    type: "Standing",
    name: "Education and Workforce",
    parent: null,
    location: "Room 327, House Office Building, Lansing, MI",
    clerk: "Brittany Middaugh",
    clerk_phone: "(517) 373-8474",
    clerk_email: "bmiddaugh@house.mi.gov",
    members: [
      { name: "Nancy DeBoer", role: "Chair" },
      { name: "Rylee Linting", role: "Majority Vice Chair" },
      { name: "Jimmie Wilson Jr.", role: "Minority Vice Chair" },
      { name: "Brad Paquette", role: "Member" },
      { name: "Joseph Fox", role: "Member" },
      { name: "Tom Kunse", role: "Member" },
      { name: "Alicia St. Germaine", role: "Member" },
      { name: "Joseph Pavlov", role: "Member" },
      { name: "Matt Koleszar", role: "Member" },
      { name: "Regina Weiss", role: "Member" },
      { name: "Erin Byrnes", role: "Member" },
    ]
  },
  {
    id: "house-election-integrity",
    chamber: "House",
    type: "Standing",
    name: "Election Integrity",
    parent: null,
    location: "Room 307, House Office Building, Lansing, MI",
    clerk: "Taylor Thrush",
    clerk_phone: "(517) 373-2115",
    clerk_email: "tthrush@house.mi.gov",
    members: [
      { name: "Rachelle Smit", role: "Chair" },
      { name: "Joseph Fox", role: "Majority Vice Chair" },
      { name: "Stephen Wooden", role: "Minority Vice Chair" },
      { name: "Pat Outman", role: "Member" },
      { name: "Gregory Alexander", role: "Member" },
      { name: "Mike Hoadley", role: "Member" },
      { name: "Joseph Pavlov", role: "Member" },
      { name: "Matt Koleszar", role: "Member" },
      { name: "Mai Xiong", role: "Member" },
    ]
  },
  {
    id: "house-energy",
    chamber: "House",
    type: "Standing",
    name: "Energy",
    parent: null,
    location: "Room 519, House Office Building, Lansing, MI",
    clerk: "Dakota Soda",
    clerk_phone: "(517) 373-0350",
    clerk_email: "dsoda@house.mi.gov",
    members: [
      { name: "Pauline Wendzel", role: "Chair" },
      { name: "David Prestin", role: "Majority Vice Chair" },
      { name: "Joseph Tate", role: "Minority Vice Chair" },
      { name: "David Martin", role: "Member" },
      { name: "Brian BeGole", role: "Member" },
      { name: "Nancy DeBoer", role: "Member" },
      { name: "Kathy Schmaltz", role: "Member" },
      { name: "Jamie Thompson", role: "Member" },
      { name: "Parker Fairbairn", role: "Member" },
      { name: "Steve Frisbie", role: "Member" },
      { name: "Rylee Linting", role: "Member" },
      { name: "Julie Brixie", role: "Member" },
      { name: "Tullio Liberati", role: "Member" },
      { name: "Joey Andrews", role: "Member" },
      { name: "Betsy Coffia", role: "Member" },
      { name: "Peter Herzberg", role: "Member" },
      { name: "Tonya Myers Phillips", role: "Member" },
    ]
  },
  {
    id: "house-families-veterans",
    chamber: "House",
    type: "Standing",
    name: "Families and Veterans",
    parent: null,
    location: "Room 307, House Office Building, Lansing, MI",
    clerk: "Keith Feldpausch",
    clerk_phone: "(517) 373-1260",
    clerk_email: "kfeldpausch@house.mi.gov",
    members: [
      { name: "Kathy Schmaltz", role: "Chair" },
      { name: "Douglas Wozniak", role: "Majority Vice Chair" },
      { name: "Stephanie Young", role: "Minority Vice Chair" },
      { name: "Joseph Fox", role: "Member" },
      { name: "Gina Johnsen", role: "Member" },
      { name: "Jamie Thompson", role: "Member" },
      { name: "Joseph Pavlov", role: "Member" },
      { name: "Jason Woolford", role: "Member" },
      { name: "Erin Byrnes", role: "Member" },
      { name: "Carrie Rheingans", role: "Member" },
      { name: "Mai Xiong", role: "Member" },
    ]
  },
  {
    id: "house-finance",
    chamber: "House",
    type: "Standing",
    name: "Finance",
    parent: null,
    location: "Room 521, House Office Building, Lansing, MI",
    clerk: "Hazel Campbell-Crawley",
    clerk_phone: "(517) 373-5671",
    clerk_email: "hcrawley@house.mi.gov",
    members: [
      { name: "Mark Tisdel", role: "Chair" },
      { name: "Steve Frisbie", role: "Majority Vice Chair" },
      { name: "Jason Hoskins", role: "Minority Vice Chair" },
      { name: "Curtis Vanderwall", role: "Member" },
      { name: "Sarah Lightner", role: "Member" },
      { name: "David Martin", role: "Member" },
      { name: "Bryan Posthumus", role: "Member" },
      { name: "Gregory Alexander", role: "Member" },
      { name: "Joseph Aragona", role: "Member" },
      { name: "Bill G. Schuette", role: "Member" },
      { name: "Tyrone Carter", role: "Member" },
      { name: "Cynthia Neeley", role: "Member" },
      { name: "Kelly Breen", role: "Member" },
      { name: "Stephanie Young", role: "Member" },
      { name: "Veronica Paiz", role: "Member" },
    ]
  },
  {
    id: "house-government-operations",
    chamber: "House",
    type: "Standing",
    name: "Government Operations",
    parent: null,
    location: "Room 307, House Office Building, Lansing, MI",
    clerk: "Keith Feldpausch",
    clerk_phone: "(517) 373-1260",
    clerk_email: "kfeldpausch@house.mi.gov",
    members: [
      { name: "Brian BeGole", role: "Chair" },
      { name: "Mike Harris", role: "Majority Vice Chair" },
      { name: "John Fitzgerald", role: "Minority Vice Chair" },
      { name: "Curtis VanderWall", role: "Member" },
      { name: "Mike McFall", role: "Member" },
    ]
  },
  {
    id: "house-health-policy",
    chamber: "House",
    type: "Standing",
    name: "Health Policy",
    parent: null,
    location: "Room 519, House Office Building, Lansing, MI",
    clerk: "Hazel Campbell-Crawley",
    clerk_phone: "(517) 373-5671",
    clerk_email: "hcrawley@house.mi.gov",
    members: [
      { name: "Curtis VanderWall", role: "Chair" },
      { name: "Jamie Thompson", role: "Majority Vice Chair" },
      { name: "Karen Whitsett", role: "Minority Vice Chair" },
      { name: "Luke Meerman", role: "Member" },
      { name: "Mark Tisdel", role: "Member" },
      { name: "Matt Bierlein", role: "Member" },
      { name: "Nancy DeBoer", role: "Member" },
      { name: "David Prestin", role: "Member" },
      { name: "Kathy Schmaltz", role: "Member" },
      { name: "Alicia St. Germaine", role: "Member" },
      { name: "Karl Bohnak", role: "Member" },
      { name: "Steve Frisbie", role: "Member" },
      { name: "Brenda Carter", role: "Member" },
      { name: "Angela Witwer", role: "Member" },
      { name: "Cynthia Neeley", role: "Member" },
      { name: "Jason Hoskins", role: "Member" },
      { name: "Morgan Foreman", role: "Member" },
    ]
  },
  {
    id: "house-insurance",
    chamber: "House",
    type: "Standing",
    name: "Insurance",
    parent: null,
    location: "Room 521, House Office Building, Lansing, MI",
    clerk: "Keith Feldpausch",
    clerk_phone: "(517) 373-1260",
    clerk_email: "kfeldpausch@house.mi.gov",
    members: [
      { name: "Mike Harris", role: "Chair" },
      { name: "Mark Tisdel", role: "Majority Vice Chair" },
      { name: "Brenda Carter", role: "Minority Vice Chair" },
      { name: "Sarah Lightner", role: "Member" },
      { name: "Bryan Posthumus", role: "Member" },
      { name: "Joseph Aragona", role: "Member" },
      { name: "Jerry Neyer", role: "Member" },
      { name: "Bill G. Schuette", role: "Member" },
      { name: "Joseph Tate", role: "Member" },
      { name: "Karen Whitsett", role: "Member" },
      { name: "John Fitzgerald", role: "Member" },
    ]
  },
  {
    id: "house-judiciary",
    chamber: "House",
    type: "Standing",
    name: "Judiciary",
    parent: null,
    location: "Room 521, House Office Building, Lansing, MI",
    clerk: "Melissa Sweet",
    clerk_phone: "(517) 373-5176",
    clerk_email: "msweet@house.mi.gov",
    members: [
      { name: "Sarah Lightner", role: "Chair" },
      { name: "Brian BeGole", role: "Majority Vice Chair" },
      { name: "Tyrone Carter", role: "Minority Vice Chair" },
      { name: "Douglas Wozniak", role: "Member" },
      { name: "Mike Harris", role: "Member" },
      { name: "Jay DeBoyer", role: "Member" },
      { name: "Gina Johnsen", role: "Member" },
      { name: "Bill G. Schuette", role: "Member" },
      { name: "Kara Hope", role: "Member" },
      { name: "Kelly Breen", role: "Member" },
      { name: "Helena Scott", role: "Member" },
    ]
  },
  {
    id: "house-natural-resources-tourism",
    chamber: "House",
    type: "Standing",
    name: "Natural Resources and Tourism",
    parent: null,
    location: "Room 519, House Office Building, Lansing, MI",
    clerk: "Taylor Thrush",
    clerk_phone: "(517) 373-2115",
    clerk_email: "tthrush@house.mi.gov",
    members: [
      { name: "David Martin", role: "Chair" },
      { name: "Alicia St. Germaine", role: "Majority Vice Chair" },
      { name: "Mike McFall", role: "Minority Vice Chair" },
      { name: "Curtis VanderWall", role: "Member" },
      { name: "Pat Outman", role: "Member" },
      { name: "Mike Hoadley", role: "Member" },
      { name: "Gina Johnsen", role: "Member" },
      { name: "David Prestin", role: "Member" },
      { name: "Karl Bohnak", role: "Member" },
      { name: "Parker Fairbairn", role: "Member" },
      { name: "Jennifer Wortz", role: "Member" },
      { name: "Helena Scott", role: "Member" },
      { name: "Regina Weiss", role: "Member" },
      { name: "Noah Arbit", role: "Member" },
      { name: "Morgan Foreman", role: "Member" },
      { name: "Tonya Myers Phillips", role: "Member" },
      { name: "Stephen Wooden", role: "Member" },
    ]
  },
  {
    id: "house-oversight",
    chamber: "House",
    type: "Standing",
    name: "Oversight",
    parent: null,
    location: "Room 352, House Appropriations, State Capitol Building, Lansing, MI",
    clerk: "Eddie Sleeper",
    clerk_phone: "(517) 373-5024",
    clerk_email: "esleeper@house.mi.gov",
    members: [
      { name: "Jay DeBoyer", role: "Chair" },
      { name: "Matt Bierlein", role: "Majority Vice Chair" },
      { name: "Reggie Miller", role: "Minority Vice Chair" },
      { name: "Luke Meerman", role: "Member" },
      { name: "Brad Paquette", role: "Member" },
      { name: "Steve Carra", role: "Member" },
      { name: "William Bruck", role: "Member" },
      { name: "Jaime Greene", role: "Member" },
      { name: "Angela Rigas", role: "Member" },
      { name: "Josh Schriver", role: "Member" },
      { name: "Jason Woolford", role: "Member" },
      { name: "Laurie Pohutsky", role: "Member" },
      { name: "Jennifer Conlin", role: "Member" },
      { name: "Sharon MacDonell", role: "Member" },
      { name: "Denise Mentzer", role: "Member" },
      { name: "Penelope Tsernoglou", role: "Member" },
      { name: "Dylan Wegela", role: "Member" },
    ]
  },
  {
    id: "house-regulatory-reform",
    chamber: "House",
    type: "Standing",
    name: "Regulatory Reform",
    parent: null,
    location: "Room 519, House Office Building, Lansing, MI",
    clerk: "Melissa Sweet",
    clerk_phone: "(517) 373-5176",
    clerk_email: "msweet@house.mi.gov",
    members: [
      { name: "Joseph Aragona", role: "Chair" },
      { name: "Parker Fairbairn", role: "Majority Vice Chair" },
      { name: "Tullio Liberati", role: "Minority Vice Chair" },
      { name: "Douglas Wozniak", role: "Member" },
      { name: "Pauline Wendzel", role: "Member" },
      { name: "Mark Tisdel", role: "Member" },
      { name: "Mike Hoadley", role: "Member" },
      { name: "Jerry Neyer", role: "Member" },
      { name: "Angela Rigas", role: "Member" },
      { name: "Jamie Thompson", role: "Member" },
      { name: "Rylee Linting", role: "Member" },
      { name: "Tyrone Carter", role: "Member" },
      { name: "Karen Whitsett", role: "Member" },
      { name: "Angela Witwer", role: "Member" },
      { name: "Cynthia Neeley", role: "Member" },
      { name: "Emily Dievendorf", role: "Member" },
      { name: "Kristian Grant", role: "Member" },
    ]
  },
  {
    id: "house-rules",
    chamber: "House",
    type: "Standing",
    name: "Rules",
    parent: null,
    location: "Room 519, House Office Building, Lansing, MI",
    clerk: "Taylor Thrush",
    clerk_phone: "(517) 373-2115",
    clerk_email: "tthrush@house.mi.gov",
    members: [
      { name: "Bill G. Schuette", role: "Chair" },
      { name: "Joseph Aragona", role: "Majority Vice Chair" },
      { name: "Angela Witwer", role: "Minority Vice Chair" },
      { name: "Pauline Wendzel", role: "Member" },
      { name: "David Martin", role: "Member" },
      { name: "Bryan Posthumus", role: "Member" },
      { name: "Nancy DeBoer", role: "Member" },
      { name: "Tullio Liberati", role: "Member" },
      { name: "Peter Herzberg", role: "Member" },
    ]
  },
  {
    id: "house-transportation-infrastructure",
    chamber: "House",
    type: "Standing",
    name: "Transportation and Infrastructure",
    parent: null,
    location: "Room 519, House Office Building, Lansing, MI",
    clerk: "Melissa Sweet",
    clerk_phone: "(517) 373-5176",
    clerk_email: "msweet@house.mi.gov",
    members: [
      { name: "Pat Outman", role: "Chair" },
      { name: "Gregory Alexander", role: "Majority Vice Chair" },
      { name: "Peter Herzberg", role: "Minority Vice Chair" },
      { name: "Steve Carra", role: "Member" },
      { name: "William Bruck", role: "Member" },
      { name: "Tom Kunse", role: "Member" },
      { name: "Jerry Neyer", role: "Member" },
      { name: "David Prestin", role: "Member" },
      { name: "Karl Bohnak", role: "Member" },
      { name: "Steve Frisbie", role: "Member" },
      { name: "Jennifer Wortz", role: "Member" },
      { name: "Kara Hope", role: "Member" },
      { name: "Matt Koleszar", role: "Member" },
      { name: "Joey Andrews", role: "Member" },
      { name: "Kristian Grant", role: "Member" },
      { name: "Reggie Miller", role: "Member" },
      { name: "Jimmie Wilson Jr.", role: "Member" },
    ]
  },

  // ─── HOUSE APPROPRIATIONS SUBCOMMITTEES ───────────────────
  {
    id: "house-approp-medicaid-behavioral-health",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Medicaid and Behavioral Health",
    parent: "house-appropriations",
    location: "Room 326, House Office Building, Lansing, MI",
    clerk: "Kent Dell",
    clerk_phone: "(517) 373-8080",
    clerk_email: "kdell@house.mi.gov",
    members: [
      { name: "Greg VanWoerkom", role: "Chair" },
      { name: "Phil Green", role: "Majority Vice Chair" },
      { name: "Julie Rogers", role: "Minority Vice Chair" },
      { name: "John Roth", role: "Member" },
      { name: "Tom Kuhn", role: "Member" },
      { name: "Ron Robinson", role: "Member" },
      { name: "Carol Glanville", role: "Member" },
    ]
  },
  {
    id: "house-approp-public-health",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Public Health",
    parent: "house-appropriations",
    location: "Room 327, House Office Building, Lansing, MI",
    clerk: "Sydney Brown",
    clerk_phone: "(517) 373-8080",
    clerk_email: "sbrown@house.mi.gov",
    members: [
      { name: "Phil Green", role: "Chair" },
      { name: "Tom Kuhn", role: "Majority Vice Chair" },
      { name: "Natalie Price", role: "Minority Vice Chair" },
      { name: "Matt Maddock", role: "Member" },
      { name: "Bradley Slagh", role: "Member" },
      { name: "Donni Steele", role: "Member" },
      { name: "Amos O'Neal", role: "Member" },
    ]
  },
  {
    id: "house-approp-human-services",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Human Services",
    parent: "house-appropriations",
    location: "Room 521, House Office Building, Lansing, MI",
    clerk: "Sydney Brown",
    clerk_phone: "(517) 373-8080",
    clerk_email: "sbrown@house.mi.gov",
    members: [
      { name: "John Roth", role: "Chair" },
      { name: "Tim Kelly", role: "Majority Vice Chair" },
      { name: "Kimberly Edwards", role: "Minority Vice Chair" },
      { name: "Mike Mueller", role: "Member" },
      { name: "Timothy Beson", role: "Member" },
      { name: "James DeSana", role: "Member" },
      { name: "Matt Longjohn", role: "Member" },
    ]
  },
  {
    id: "house-approp-egle",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Environment, Great Lakes, and Energy",
    parent: "house-appropriations",
    location: "Room 308, House Office Building, Lansing, MI",
    clerk: "Austin Scott",
    clerk_phone: "(517) 373-8080",
    clerk_email: "ascott@house.mi.gov",
    members: [
      { name: "Cameron Cavitt", role: "Chair" },
      { name: "Ken Borton", role: "Majority Vice Chair" },
      { name: "Samantha Steckloff", role: "Minority Vice Chair" },
      { name: "Greg Markkanen", role: "Member" },
      { name: "Natalie Price", role: "Member" },
    ]
  },
  {
    id: "house-approp-agriculture-natural-resources",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Agriculture and Rural Development and Natural Resources",
    parent: "house-appropriations",
    location: "Room 352, House Appropriations, State Capitol Building, Lansing, MI",
    clerk: "William Hamilton",
    clerk_phone: "(517) 373-8080",
    clerk_email: "whamilt@house.mi.gov",
    members: [
      { name: "Ken Borton", role: "Chair" },
      { name: "Mike Mueller", role: "Majority Vice Chair" },
      { name: "Amos O'Neal", role: "Minority Vice Chair" },
      { name: "Phil Green", role: "Member" },
      { name: "John Roth", role: "Member" },
      { name: "James DeSana", role: "Member" },
      { name: "Donavan McKinney", role: "Member" },
    ]
  },
  {
    id: "house-approp-higher-education",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Higher Education and Community Colleges",
    parent: "house-appropriations",
    location: "Room 352, House Appropriations, State Capitol Building, Lansing, MI",
    clerk: "Perry Zielak",
    clerk_phone: "(517) 373-8080",
    clerk_email: "pzielak@house.mi.gov",
    members: [
      { name: "Greg Markkanen", role: "Chair" },
      { name: "John Roth", role: "Vice Chair" },
      { name: "Matt Longjohn", role: "Minority Vice Chair" },
      { name: "Thomas Kuhn", role: "Member" },
      { name: "Nancy Jenkins-Arno", role: "Member" },
      { name: "Mike Mueller", role: "Member" },
      { name: "Julie Rogers", role: "Member" },
    ]
  },
  {
    id: "house-approp-msp",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Michigan State Police",
    parent: "house-appropriations",
    location: "Room 307, House Office Building, Lansing, MI",
    clerk: "Aaron Meek",
    clerk_phone: "(517) 373-0350",
    clerk_email: "ameek@house.mi.gov",
    members: [
      { name: "Mike Mueller", role: "Chair" },
      { name: "Matt Maddock", role: "Majority Vice Chair" },
      { name: "Will Snyder", role: "Minority Vice Chair" },
      { name: "Tim Kelly", role: "Member" },
      { name: "Jasper Martus", role: "Member" },
    ]
  },
  {
    id: "house-approp-general-government",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — General Government",
    parent: "house-appropriations",
    location: "Room 307, House Office Building, Lansing, MI",
    clerk: "Michael Cnossen",
    clerk_phone: "(517) 373-8080",
    clerk_email: "mcnossen@house.mi.gov",
    members: [
      { name: "Tom Kuhn", role: "Chair" },
      { name: "Greg VanWoerkom", role: "Majority Vice Chair" },
      { name: "Will Snyder", role: "Minority Vice Chair" },
      { name: "Tim Kelly", role: "Member" },
      { name: "Matt Maddock", role: "Member" },
    ]
  },
  {
    id: "house-approp-lara",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Licensing and Regulatory Affairs, Insurance and Financial Service",
    parent: "house-appropriations",
    location: "Room 327, House Office Building, Lansing, MI",
    clerk: "Una Jakupovic",
    clerk_phone: "(517) 373-8080",
    clerk_email: "ujakupovic@house.mi.gov",
    members: [
      { name: "Timothy Beson", role: "Chair" },
      { name: "Donni Steele", role: "Majority Vice Chair" },
      { name: "Donavan McKinney", role: "Minority Vice Chair" },
      { name: "Greg VanWoerkom", role: "Member" },
      { name: "Will Snyder", role: "Member" },
    ]
  },
  {
    id: "house-approp-joint-capital-outlay",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Joint Capital Outlay",
    parent: "house-appropriations",
    location: "Room 352, House Appropriations, State Capitol Building, Lansing, MI",
    clerk: "Dakota Soda",
    clerk_phone: "(517) 373-0350",
    clerk_email: "dsoda@house.mi.gov",
    members: [
      { name: "Nancy Jenkins-Arno", role: "Chair" },
      { name: "James DeSana", role: "Majority Vice Chair" },
      { name: "Samantha Steckloff", role: "Minority Vice Chair" },
      { name: "Ann Bollin", role: "Member" },
      { name: "Phil Green", role: "Member" },
      { name: "Bradley Slagh", role: "Member" },
      { name: "Donni Steele", role: "Member" },
      { name: "Carol Glanville", role: "Member" },
      { name: "Alabas Farhat", role: "Member" },
      { name: "Jeff Irwin", role: "Member (Senate)" },
      { name: "Sean McCann", role: "Member (Senate)" },
      { name: "Mallory McMorrow", role: "Member (Senate)" },
      { name: "Sylvia Santana", role: "Member (Senate)" },
      { name: "John Damoose", role: "Member (Senate)" },
      { name: "Jon Bumstead", role: "Member (Senate)" },
      { name: "Mark Huizenga", role: "Member (Senate)" },
    ]
  },
  {
    id: "house-approp-school-aid",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — School Aid and Department of Education",
    parent: "house-appropriations",
    location: "Room 326, House Office Building, Lansing, MI",
    clerk: "Jacqueline Mullen",
    clerk_phone: "(517) 373-8080",
    clerk_email: "jmullen@house.mi.gov",
    members: [
      { name: "Tim Kelly", role: "Chair" },
      { name: "Nancy Jenkins-Arno", role: "Majority Vice Chair" },
      { name: "Carol Glanville", role: "Minority Vice Chair" },
      { name: "Greg Markkanen", role: "Member" },
      { name: "Timothy Beson", role: "Member" },
      { name: "Ken Borton", role: "Member" },
      { name: "Samantha Steckloff", role: "Member" },
    ]
  },
  {
    id: "house-approp-military-veterans",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Military and Veterans",
    parent: "house-appropriations",
    location: "Room 308, House Office Building, Lansing, MI",
    clerk: "Aaron Meek",
    clerk_phone: "(517) 373-8080",
    clerk_email: "ameek@house.mi.gov",
    members: [
      { name: "Ron Robinson", role: "Chair" },
      { name: "Cameron Cavitt", role: "Majority Vice Chair" },
      { name: "Julie Rogers", role: "Minority Vice Chair" },
      { name: "Matt Maddock", role: "Member" },
      { name: "Jason Morgan", role: "Member" },
    ]
  },
  {
    id: "house-approp-state-local-transportation",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — State and Local Transportation",
    parent: "house-appropriations",
    location: "Room 307, House Office Building, Lansing, MI",
    clerk: "William Hamilton",
    clerk_phone: "(517) 373-8080",
    clerk_email: "whamilt@house.mi.gov",
    members: [
      { name: "Donni Steele", role: "Chair" },
      { name: "Bradley Slagh", role: "Majority Vice Chair" },
      { name: "Jason Morgan", role: "Minority Vice Chair" },
      { name: "Ken Borton", role: "Member" },
      { name: "James DeSana", role: "Member" },
      { name: "Ron Robinson", role: "Member" },
      { name: "Kimberly Edwards", role: "Member" },
    ]
  },
  {
    id: "house-approp-corrections-judiciary",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Corrections and Judiciary",
    parent: "house-appropriations",
    location: "Room 326, House Office Building, Lansing, MI",
    clerk: "Robin Risko",
    clerk_phone: "(517) 373-8080",
    clerk_email: "rrisko@house.mi.gov",
    members: [
      { name: "Bradley Slagh", role: "Chair" },
      { name: "Greg Markkanen", role: "Majority Vice Chair" },
      { name: "Amos O'Neal", role: "Minority Vice Chair" },
      { name: "Timothy Beson", role: "Member" },
      { name: "Cameron Cavitt", role: "Member" },
    ]
  },
  {
    id: "house-approp-labor-economic-opportunity",
    chamber: "House",
    type: "Subcommittee",
    name: "Appropriations — Labor and Economic Opportunity",
    parent: "house-appropriations",
    location: "Room 307, House Office Building, Lansing, MI",
    clerk: "Marcus Coffin",
    clerk_phone: "(517) 373-8080",
    clerk_email: "mcoffin@house.mi.gov",
    members: [
      { name: "Nancy Jenkins-Arno", role: "Chair" },
      { name: "Ron Robinson", role: "Majority Vice Chair" },
      { name: "Jasper Martus", role: "Minority Vice Chair" },
      { name: "Greg VanWoerkom", role: "Member" },
      { name: "Cameron Cavitt", role: "Member" },
    ]
  },

  // ─── HOUSE OVERSIGHT SUBCOMMITTEES ────────────────────────
  {
    id: "house-oversight-weaponization",
    chamber: "House",
    type: "Subcommittee",
    name: "Oversight — Weaponization of State Government",
    parent: "house-oversight",
    location: "Room 308, House Office Building, Lansing, MI",
    clerk: "Taylor Thrush",
    clerk_phone: "(517) 373-2115",
    clerk_email: "tthrush@house.mi.gov",
    members: [
      { name: "Angela Rigas", role: "Chair" },
      { name: "Josh Schriver", role: "Majority Vice Chair" },
      { name: "Laurie Pohutsky", role: "Minority Vice Chair" },
      { name: "Jason Woolford", role: "Member" },
      { name: "Dylan Wegela", role: "Member" },
    ]
  },
  {
    id: "house-oversight-child-welfare",
    chamber: "House",
    type: "Subcommittee",
    name: "Oversight — Child Welfare System",
    parent: "house-oversight",
    location: "Room 308, House Office Building, Lansing, MI",
    clerk: "Matthew Carnagie",
    clerk_phone: "(517) 373-5795",
    clerk_email: "mcarnagie@house.mi.gov",
    members: [
      { name: "Luke Meerman", role: "Chair" },
      { name: "Angela Rigas", role: "Majority Vice Chair" },
      { name: "Jennifer Conlin", role: "Minority Vice Chair" },
      { name: "Brad Paquette", role: "Member" },
      { name: "Sharon MacDonell", role: "Member" },
    ]
  },
  {
    id: "house-oversight-corporate-subsidies",
    chamber: "House",
    type: "Subcommittee",
    name: "Oversight — Corporate Subsidies and State Investments",
    parent: "house-oversight",
    location: "Room 326, House Office Building, Lansing, MI",
    clerk: "Matthew Carnagie",
    clerk_phone: "(517) 373-5795",
    clerk_email: "mcarnagie@house.mi.gov",
    members: [
      { name: "Steve Carra", role: "Chair" },
      { name: "Jaime Greene", role: "Majority Vice Chair" },
      { name: "Dylan Wegela", role: "Minority Vice Chair" },
      { name: "Matt Bierlein", role: "Member" },
      { name: "Laurie Pohutsky", role: "Member" },
    ]
  },
  {
    id: "house-oversight-public-health-food",
    chamber: "House",
    type: "Subcommittee",
    name: "Oversight — Public Health and Food Security",
    parent: "house-oversight",
    location: "Room 326, House Office Building, Lansing, MI",
    clerk: "Eddie Sleeper",
    clerk_phone: "(517) 373-5024",
    clerk_email: "esleeper@house.mi.gov",
    members: [
      { name: "Matt Bierlein", role: "Chair" },
      { name: "Brad Paquette", role: "Majority Vice Chair" },
      { name: "Sharon MacDonell", role: "Minority Vice Chair" },
      { name: "Jaime Greene", role: "Member" },
      { name: "Penelope Tsernoglou", role: "Member" },
    ]
  },
  {
    id: "house-oversight-homeland-security",
    chamber: "House",
    type: "Subcommittee",
    name: "Oversight — Homeland Security and Foreign Influence",
    parent: "house-oversight",
    location: "Room 308, House Office Building, Lansing, MI",
    clerk: "Matthew Carnagie",
    clerk_phone: "(517) 373-5795",
    clerk_email: "mcarnagie@house.mi.gov",
    members: [
      { name: "William Bruck", role: "Chair" },
      { name: "Luke Meerman", role: "Majority Vice Chair" },
      { name: "Denise Mentzer", role: "Minority Vice Chair" },
      { name: "Josh Schriver", role: "Member" },
      { name: "Jennifer Conlin", role: "Member" },
    ]
  },
  {
    id: "house-oversight-state-local-assistance",
    chamber: "House",
    type: "Subcommittee",
    name: "Oversight — State and Local Public Assistance Programs",
    parent: "house-oversight",
    location: "Room 326, House Office Building, Lansing, MI",
    clerk: "Hazel Campbell-Crawley",
    clerk_phone: "(517) 373-5671",
    clerk_email: "hcrawley@house.mi.gov",
    members: [
      { name: "Jason Woolford", role: "Chair" },
      { name: "William Bruck", role: "Majority Vice Chair" },
      { name: "Penelope Tsernoglou", role: "Minority Vice Chair" },
      { name: "Steve Carra", role: "Member" },
      { name: "Denise Mentzer", role: "Member" },
    ]
  },

  {
    id: "house-jcar",
    chamber: "House",
    type: "Standing",
    name: "Joint Committee on Administrative Rules (JCAR)",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Douglas Wozniak", role: "Chair" },
      { name: "Gina Johnsen", role: "Member" },
      { name: "Jennifer Wortz", role: "Member" },
      { name: "Alabas Farhat", role: "Member" },
      { name: "Brenda Carter", role: "Member" },
    ]
  },

  // ─── SENATE STANDING COMMITTEES ───────────────────────────
  {
    id: "senate-appropriations",
    chamber: "Senate",
    type: "Standing",
    name: "Appropriations",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Sarah Anthony", role: "Chair" },
      { name: "Sean McCann", role: "Vice Chair" },
      { name: "Jon Bumstead", role: "Minority Vice Chair" },
      { name: "Darrin Camilleri", role: "Member" },
      { name: "Rosemary Bayer", role: "Member" },
      { name: "Sylvia Santana", role: "Member" },
      { name: "Mary Cavanagh", role: "Member" },
      { name: "Jeff Irwin", role: "Member" },
      { name: "Kevin Hertel", role: "Member" },
      { name: "Mallory McMorrow", role: "Member" },
      { name: "Brian Cherry", role: "Member" },
      { name: "Sam Singh", role: "Member" },
      { name: "Stephanie Chang", role: "Member" },
      { name: "Erika Geiss", role: "Member" },
      { name: "Sue Shink", role: "Member" },
      { name: "Veronica Klinefelt", role: "Member" },
      { name: "Ed McBroom", role: "Member" },
      { name: "John Albert", role: "Member" },
      { name: "John Damoose", role: "Member" },
      { name: "Mark Huizenga", role: "Member" },
      { name: "Rick Outman", role: "Member" },
      { name: "Lana Theis", role: "Member" },
    ]
  },
  {
    id: "senate-civil-rights-judiciary",
    chamber: "Senate",
    type: "Standing",
    name: "Civil Rights, Judiciary, and Public Safety",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Stephanie Chang", role: "Chair" },
      { name: "Sue Shink", role: "Vice Chair" },
      { name: "Jim Runestad", role: "Minority Vice Chair" },
      { name: "Paul Wojno", role: "Member" },
      { name: "Jeff Irwin", role: "Member" },
      { name: "Sylvia Santana", role: "Member" },
      { name: "Ruth Johnson", role: "Member" },
    ]
  },
  {
    id: "senate-economic-community-development",
    chamber: "Senate",
    type: "Standing",
    name: "Economic and Community Development",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Mallory McMorrow", role: "Chair" },
      { name: "Mary Cavanagh", role: "Vice Chair" },
      { name: "Dan Victory", role: "Minority Vice Chair" },
      { name: "Dayna Polehanki", role: "Member" },
      { name: "Erika Geiss", role: "Member" },
      { name: "John Lindsey", role: "Member" },
      { name: "Tom Webber", role: "Member" },
    ]
  },
  {
    id: "senate-education",
    chamber: "Senate",
    type: "Standing",
    name: "Education",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Dayna Polehanki", role: "Chair" },
      { name: "Erika Geiss", role: "Vice Chair" },
      { name: "John Damoose", role: "Minority Vice Chair" },
      { name: "Stephanie Chang", role: "Member" },
      { name: "Darrin Camilleri", role: "Member" },
      { name: "Jeff Irwin", role: "Member" },
      { name: "Ruth Johnson", role: "Member" },
    ]
  },
  {
    id: "senate-elections-ethics",
    chamber: "Senate",
    type: "Standing",
    name: "Elections and Ethics",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Paul Wojno", role: "Vice Chair" },
      { name: "Ruth Johnson", role: "Minority Vice Chair" },
      { name: "Sylvia Santana", role: "Member" },
      { name: "Mallory McMorrow", role: "Member" },
      { name: "Stephanie Chang", role: "Member" },
      { name: "Ed McBroom", role: "Member" },
    ]
  },
  {
    id: "senate-energy-environment",
    chamber: "Senate",
    type: "Standing",
    name: "Energy and Environment",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Sean McCann", role: "Chair" },
      { name: "Sam Singh", role: "Vice Chair" },
      { name: "Dan Lauwers", role: "Minority Vice Chair" },
      { name: "Rosemary Bayer", role: "Member" },
      { name: "Sue Shink", role: "Member" },
      { name: "Kevin Hertel", role: "Member" },
      { name: "Darrin Camilleri", role: "Member" },
      { name: "Stephanie Chang", role: "Member" },
      { name: "Dayna Polehanki", role: "Member" },
      { name: "John Damoose", role: "Member" },
      { name: "Rick Outman", role: "Member" },
      { name: "Mark Hauck", role: "Member" },
      { name: "Joseph Bellino", role: "Member" },
    ]
  },
  {
    id: "senate-finance-insurance-consumer",
    chamber: "Senate",
    type: "Standing",
    name: "Finance, Insurance, and Consumer Protection",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Mary Cavanagh", role: "Chair" },
      { name: "Jeff Irwin", role: "Vice Chair" },
      { name: "Mark Huizenga", role: "Minority Vice Chair" },
      { name: "Sean McCann", role: "Member" },
      { name: "Rosemary Bayer", role: "Member" },
      { name: "Darrin Camilleri", role: "Member" },
      { name: "Lana Theis", role: "Member" },
      { name: "Dale Daley", role: "Member" },
    ]
  },
  {
    id: "senate-government-operations",
    chamber: "Senate",
    type: "Standing",
    name: "Government Operations",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Winnie Brinks", role: "Chair" },
      { name: "Sam Singh", role: "Vice Chair" },
      { name: "Mike Nesbitt", role: "Minority Vice Chair" },
      { name: "Dan Lauwers", role: "Member" },
    ]
  },
  {
    id: "senate-health-policy",
    chamber: "Senate",
    type: "Standing",
    name: "Health Policy",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Kevin Hertel", role: "Chair" },
      { name: "Sylvia Santana", role: "Vice Chair" },
      { name: "Tom Webber", role: "Minority Vice Chair" },
      { name: "Paul Wojno", role: "Member" },
      { name: "Brian Cherry", role: "Member" },
      { name: "Veronica Klinefelt", role: "Member" },
      { name: "Erika Geiss", role: "Member" },
      { name: "Mark Hauck", role: "Member" },
      { name: "Mark Huizenga", role: "Member" },
      { name: "Jim Runestad", role: "Member" },
    ]
  },
  {
    id: "senate-housing-human-services",
    chamber: "Senate",
    type: "Standing",
    name: "Housing and Human Services",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Jeff Irwin", role: "Chair" },
      { name: "Sylvia Santana", role: "Vice Chair" },
      { name: "John Lindsey", role: "Minority Vice Chair" },
      { name: "Mary Cavanagh", role: "Member" },
      { name: "Rosemary Bayer", role: "Member" },
      { name: "Sue Shink", role: "Member" },
      { name: "Stephanie Chang", role: "Member" },
      { name: "Brian Cherry", role: "Member" },
      { name: "Erika Geiss", role: "Member" },
      { name: "Michele Hoitenga", role: "Member" },
      { name: "John Damoose", role: "Member" },
    ]
  },
  {
    id: "senate-jcar",
    chamber: "Senate",
    type: "Standing",
    name: "JCAR (Joint Committee on Administrative Rules)",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Paul Wojno", role: "Chair" },
      { name: "Rosemary Bayer", role: "Member" },
      { name: "Mallory McMorrow", role: "Member" },
      { name: "Lana Theis", role: "Member" },
      { name: "Jim Runestad", role: "Member" },
    ]
  },
  {
    id: "senate-labor",
    chamber: "Senate",
    type: "Standing",
    name: "Labor",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Brian Cherry", role: "Chair" },
      { name: "Darrin Camilleri", role: "Vice Chair" },
      { name: "John Albert", role: "Minority Vice Chair" },
      { name: "Mary Cavanagh", role: "Member" },
    ]
  },
  {
    id: "senate-local-government",
    chamber: "Senate",
    type: "Standing",
    name: "Local Government",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Veronica Klinefelt", role: "Chair" },
      { name: "Paul Wojno", role: "Vice Chair" },
      { name: "Michele Hoitenga", role: "Minority Vice Chair" },
      { name: "Rosemary Bayer", role: "Member" },
      { name: "Sue Shink", role: "Member" },
      { name: "Dale Daley", role: "Member" },
    ]
  },
  {
    id: "senate-natural-resources-agriculture",
    chamber: "Senate",
    type: "Standing",
    name: "Natural Resources and Agriculture",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Sue Shink", role: "Chair" },
      { name: "Brian Cherry", role: "Vice Chair" },
      { name: "Dale Daley", role: "Minority Vice Chair" },
      { name: "Sam Singh", role: "Member" },
      { name: "Dayna Polehanki", role: "Member" },
      { name: "Dan Victory", role: "Member" },
      { name: "Michele Hoitenga", role: "Member" },
    ]
  },
  {
    id: "senate-oversight",
    chamber: "Senate",
    type: "Standing",
    name: "Oversight",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Sam Singh", role: "Chair" },
      { name: "Mallory McMorrow", role: "Vice Chair" },
      { name: "Ed McBroom", role: "Minority Vice Chair" },
      { name: "Erika Geiss", role: "Member" },
      { name: "Dayna Polehanki", role: "Member" },
      { name: "John Lindsey", role: "Member" },
    ]
  },
  {
    id: "senate-regulatory-affairs",
    chamber: "Senate",
    type: "Standing",
    name: "Regulatory Affairs",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Jeremy Moss", role: "Chair" },
      { name: "Dayna Polehanki", role: "Vice Chair" },
      { name: "Mark Hauck", role: "Minority Vice Chair" },
      { name: "Sean McCann", role: "Member" },
      { name: "Paul Wojno", role: "Member" },
      { name: "Sylvia Santana", role: "Member" },
      { name: "Kevin Hertel", role: "Member" },
      { name: "Tom Webber", role: "Member" },
      { name: "Dan Lauwers", role: "Member" },
      { name: "Joseph Bellino", role: "Member" },
    ]
  },
  {
    id: "senate-transportation-infrastructure",
    chamber: "Senate",
    type: "Standing",
    name: "Transportation and Infrastructure",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Erika Geiss", role: "Chair" },
      { name: "Veronica Klinefelt", role: "Vice Chair" },
      { name: "Joseph Bellino", role: "Minority Vice Chair" },
      { name: "Paul Wojno", role: "Member" },
      { name: "Kevin Hertel", role: "Member" },
      { name: "Stephanie Chang", role: "Member" },
      { name: "Sean McCann", role: "Member" },
      { name: "Ed McBroom", role: "Member" },
      { name: "Dan Victory", role: "Member" },
      { name: "Jon Bumstead", role: "Member" },
    ]
  },
  {
    id: "senate-veterans-emergency-services",
    chamber: "Senate",
    type: "Standing",
    name: "Veterans and Emergency Services",
    parent: null,
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Veronica Klinefelt", role: "Chair" },
      { name: "Kevin Hertel", role: "Vice Chair" },
      { name: "Rick Outman", role: "Minority Vice Chair" },
      { name: "Sylvia Santana", role: "Member" },
      { name: "John Lindsey", role: "Member" },
    ]
  },

  // ─── SENATE APPROPRIATIONS SUBCOMMITTEES ──────────────────
  {
    id: "senate-approp-agriculture-natural-resources",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — Agriculture and Natural Resources",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Brian Cherry", role: "Chair" },
      { name: "Sue Shink", role: "Vice Chair" },
      { name: "Jon Bumstead", role: "Minority Vice Chair" },
      { name: "Sam Singh", role: "Member" },
      { name: "Lana Theis", role: "Member" },
    ]
  },
  {
    id: "senate-approp-corrections-judiciary",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — Corrections and Judiciary",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Sue Shink", role: "Chair" },
      { name: "Sylvia Santana", role: "Vice Chair" },
      { name: "Rick Outman", role: "Minority Vice Chair" },
      { name: "Jeff Irwin", role: "Member" },
    ]
  },
  {
    id: "senate-approp-dhhs",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — DHHS",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Sylvia Santana", role: "Chair" },
      { name: "Brian Cherry", role: "Vice Chair" },
      { name: "Rick Outman", role: "Minority Vice Chair" },
      { name: "Jeff Irwin", role: "Member" },
      { name: "Mary Cavanagh", role: "Member" },
      { name: "Rosemary Bayer", role: "Member" },
      { name: "Veronica Klinefelt", role: "Member" },
      { name: "Mark Huizenga", role: "Member" },
      { name: "Mark Hauck", role: "Member" },
      { name: "Lana Theis", role: "Member" },
    ]
  },
  {
    id: "senate-approp-egle",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — EGLE",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Jeff Irwin", role: "Chair" },
      { name: "Sam Singh", role: "Vice Chair" },
      { name: "Jon Bumstead", role: "Minority Vice Chair" },
      { name: "Sue Shink", role: "Member" },
      { name: "Brian Cherry", role: "Member" },
      { name: "Rosemary Bayer", role: "Member" },
      { name: "Mark Hauck", role: "Member" },
      { name: "Rick Outman", role: "Member" },
    ]
  },
  {
    id: "senate-approp-general-government",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — General Government",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Brian Cherry", role: "Chair" },
      { name: "Rosemary Bayer", role: "Vice Chair" },
      { name: "John Albert", role: "Minority Vice Chair" },
      { name: "Veronica Klinefelt", role: "Member" },
      { name: "Mark Hauck", role: "Member" },
    ]
  },
  {
    id: "senate-approp-joint-capital-outlay",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — Joint Capital Outlay",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Sean McCann", role: "Chair" },
      { name: "Jeff Irwin", role: "Vice Chair" },
      { name: "John Damoose", role: "Minority Vice Chair" },
      { name: "Mallory McMorrow", role: "Member" },
      { name: "Sylvia Santana", role: "Member" },
      { name: "Rosemary Bayer", role: "Member" },
      { name: "Jon Bumstead", role: "Member" },
      { name: "Mark Huizenga", role: "Member" },
    ]
  },
  {
    id: "senate-approp-lara-difs",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — LARA/DIFS",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Mary Cavanagh", role: "Chair" },
      { name: "Sylvia Santana", role: "Vice Chair" },
      { name: "Lana Theis", role: "Minority Vice Chair" },
    ]
  },
  {
    id: "senate-approp-leo-medc",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — LEO/MEDC",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Mary Cavanagh", role: "Chair" },
      { name: "Sean McCann", role: "Vice Chair" },
      { name: "Mark Huizenga", role: "Minority Vice Chair" },
      { name: "Mallory McMorrow", role: "Member" },
      { name: "Darrin Camilleri", role: "Member" },
      { name: "Brian Cherry", role: "Member" },
      { name: "Jon Bumstead", role: "Member" },
    ]
  },
  {
    id: "senate-approp-mde",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — MDE",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Rosemary Bayer", role: "Chair" },
      { name: "Veronica Klinefelt", role: "Vice Chair" },
      { name: "John Albert", role: "Minority Vice Chair" },
    ]
  },
  {
    id: "senate-approp-military-veterans-state-police",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — Military, Veterans, State Police",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Kevin Hertel", role: "Chair" },
      { name: "Veronica Klinefelt", role: "Vice Chair" },
      { name: "Lana Theis", role: "Minority Vice Chair" },
    ]
  },
  {
    id: "senate-approp-mileap",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — MiLEAP",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Rosemary Bayer", role: "Chair" },
      { name: "Veronica Klinefelt", role: "Vice Chair" },
      { name: "John Albert", role: "Minority Vice Chair" },
    ]
  },
  {
    id: "senate-approp-prek12",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — PreK-12",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Darrin Camilleri", role: "Chair" },
      { name: "Dayna Polehanki", role: "Vice Chair" },
      { name: "Lana Theis", role: "Minority Vice Chair" },
      { name: "Kevin Hertel", role: "Member" },
      { name: "Veronica Klinefelt", role: "Member" },
      { name: "Mary Cavanagh", role: "Member" },
      { name: "Rosemary Bayer", role: "Member" },
      { name: "John Albert", role: "Member" },
    ]
  },
  {
    id: "senate-approp-transportation",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — Transportation",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Veronica Klinefelt", role: "Chair" },
      { name: "Kevin Hertel", role: "Vice Chair" },
      { name: "John Damoose", role: "Minority Vice Chair" },
      { name: "Sean McCann", role: "Member" },
      { name: "Darrin Camilleri", role: "Member" },
      { name: "Jon Bumstead", role: "Member" },
    ]
  },
  {
    id: "senate-approp-universities-community-colleges",
    chamber: "Senate",
    type: "Subcommittee",
    name: "Appropriations — Universities and Community Colleges",
    parent: "senate-appropriations",
    location: null,
    clerk: null,
    clerk_phone: null,
    clerk_email: null,
    members: [
      { name: "Sean McCann", role: "Chair" },
      { name: "Jeff Irwin", role: "Vice Chair" },
      { name: "John Damoose", role: "Minority Vice Chair" },
      { name: "Sam Singh", role: "Member" },
      { name: "John Albert", role: "Member" },
    ]
  },

];

export default MI_COMMITTEES;
